export default __webpack_public_path__ + "static/media/prime.94c066d4.svg";